/**
 * A single global tooltip, used to explain pieces on hover. Any component can
 * push text + a cursor position; one <Tooltip/> rendered at the app root shows
 * it. Kept tiny and global so every PieceIcon (board, hand, deck builder,
 * graveyard) can share it without prop drilling.
 */
import { createSignal } from "solid-js";
import type { PieceTypeId } from "../core";

export interface TooltipState {
  readonly text: string;
  /** When set, the tooltip also shows that piece's move-pattern diagram. */
  readonly type?: PieceTypeId;
  readonly x: number;
  readonly y: number;
}

const [tooltip, setTooltip] = createSignal<TooltipState | null>(null);

export { tooltip };

export function showTooltip(text: string, x: number, y: number, type?: PieceTypeId): void {
  setTooltip({ text, type, x, y });
}

export function moveTooltip(x: number, y: number): void {
  setTooltip((t) => (t ? { ...t, x, y } : t));
}

export function hideTooltip(): void {
  setTooltip(null);
}
